import React, { useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import notiifcationicon from '../../assets/images/navbar/notifcation.svg';
import dropdown from '../../assets/images/navbar/dropdown.svg';
import { Link } from "react-router-dom";
// import { Drawer } from 'rsuite';
// import 'rsuite/Drawer/styles/index.css';
// import 'rsuite/dist/rsuite.min.css'; 
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { apiUrl } from '../../config/Config';
import userplaceholderimg from '../../assets/images/userplaceholder.png';


const Navbar = (props) => {
    const [shownavdropdown, setshownavdropdown] = useState(false);
    const [sticky, setSticky] = useState("");
    const [open, setOpen] = useState(false);
    const [activenotification, setactivenotification] = useState("all");

    let navigate = useNavigate();
    const dispatch = useDispatch(); 
    const userdata = useSelector((store) => store.userReducer.userdata)

    const handlehomenavigate = () => {
      setOpen(false);
      navigate('/dashbaord');
    }

    const handlelogout = async() => {
      console.log('handlelogout');
      // setshowloding(true);
        var data = {
            
        }
        const headers = {
          headers: {
              'Content-Type': 'application/json',
              Authorization: "Bearer " + userdata?.token,
          }
      }
        let resp = await axios.post(apiUrl + 'adminlogout', data, headers).then((res) => {
            if(res.data.status == 'success') {
              dispatch({ type: "userdata", payload: {} })
      navigate('/admin/login');
            } else {
              
              if(res.data.message == 'invalid user') {
                dispatch({ type: "userdata", payload: {} })
                navigate('/login');
              } else {
                alert(res.data.message);
              }
            }
        } ).catch((err) => {
            alert(err.message)
        })
        // setshowloding(false);
      
    }


    return (
      <>
        <div className="navbarmaindiv">
          <div className="navbarrow">
            <p className="nav-pagetitle">{props.title}</p>
            {/* <div className="nav-searchdiv">
              <input
                type="text"
                className="form-control nav-searchinput"
                placeholder="Search here..."
              />
              <img src={searchicon} className="nav-searchicon" />
            </div> */}
            <div
              className="notificationbg"
              style={{ cursor: "pointer" }}
              onClick={() => {
                setOpen(true);
              }}
            >
              <img src={notiifcationicon} className="nav-notifyicon" />
            </div>
            <div
              className="nav-profilediv"
              onClick={() => {
                setshownavdropdown(!shownavdropdown);
              }}
            >
              <img src={userplaceholderimg} className="nav-userimg" />
              <div className="nav-profilenamediv">
                <p className="nav-profilename">{userdata?.name}</p>
                <p className="nav-profiledesig">{userdata?.type == 'admin' ? 'Manager' : userdata?.type}</p>
              </div>
              <div className="nav-profiledowndiv">
                <img src={dropdown} className="nav-profiledownicon" />
              </div>
              {shownavdropdown ? (
                <div className="dropdown-content" style={{ display: "block" }}>
                  {/* <div
                    className={"sidebarnavrow navbardropdownicon atag"}
                  >
                    <div className="navbarnavicon" />
                    <p className="shoppingtext">Profile</p>
                  </div> */}
                  <div
                    onClick={() => {handlelogout()}}
                    className={"sidebarnavrow navbardropdownicon atag"}
                  >
                    {/* <img src={sidebar_signout} className="sidebarnavicon" /> */}
                    <div className="navbarnavicon navbarnavicon1" />
                    <p className="shoppingtext">Sign Out</p>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        </div>

        {/* Notifications Drawer */}
        {/* <Drawer
          open={open}
          placement="right"
          onClick={() => setOpen(false)}
          onClose={() => setOpen(false)}
          backdrop={true}
          size={"xs"}
          className="notificationsidebar"
        >
          <Drawer.Body>
            <div className="navbar-sidebar-topdiv">
              <div className="navbar-sidebar-headerrow">
                <div
                  className="navbar-sidebar-header-left"
                  onClick={() => {
                    setOpen(false);
                  }}
                >
                  <img src={Navback} />
                </div>
                <p className="navbar-sidebar-header-notificationtext">
                  Notification
                </p>
                <div
                  className="navbar-sidebar-header-left-rightdiv"
                  onClick={() => {
                    handlehomenavigate();
                  }}
                >
                  <img src={Navhome} />
                </div>
              </div>
            </div>
            <div className="navbar-sidebar-tabrow d-flex">
              <div
                className="navbar-sidebar-tabdiv"
                onClick={() => {
                  setactivenotification("all");
                }}
              >
                <p
                  className="navbar-sidebar-tabname"
                  style={activenotification == "all" ? {} : { borderBottom: 0 }}
                >
                  All
                </p>
              </div>
              <div
                className="navbar-sidebar-tabdiv"
                onClick={() => {
                  setactivenotification("unread");
                }}
              >
                <p
                  className="navbar-sidebar-tabname"
                  style={
                    activenotification == "unread" ? {} : { borderBottom: 0 }
                  }
                >
                  Unread
                </p>
                <div className="navbar-sidebar-unreaddiv">
                  <p>12</p>
                </div>
              </div>
            </div>

            <div className="navbar-sidebar-tabbody">
              <div className="notification-row">
                <div className="notification-rowimgdiv">
                  <img
                    src={notificationrowicon}
                    className="notification-rowimg"
                  />
                  <div className="newnotiifcationcircle"></div>
                </div>
                <div className="notification-rowtextdiv">
                  <p className="notification-rowtitle">SALE IS LIVE</p>
                  <p className="notification-rowdesc">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit
                    dolor sit amet, consectetur adipiscing elit.
                  </p>
                </div>
                <div className="notification-rowdatediv">
                  <p className="notification-rowdate">1m ago</p>
                </div>
              </div>
              <div className="notification-row">
                <div className="notification-rowimgdiv">
                  <img
                    src={notificationrowicon}
                    className="notification-rowimg"
                  />
                  <div className="newnotiifcationcircle"></div>
                </div>
                <div className="notification-rowtextdiv">
                  <p className="notification-rowtitle">SALE IS LIVE</p>
                  <p className="notification-rowdesc">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit
                    dolor sit amet, consectetur adipiscing elit.
                  </p>
                </div>
                <div className="notification-rowdatediv">
                  <p className="notification-rowdate">1m ago</p>
                </div>
              </div>
            </div>
          </Drawer.Body>
        </Drawer> */}
      </>
    );
}

export default Navbar